import React from 'react';
import { RotateCcw, Search } from 'lucide-react';
import { RANGES } from '../callModel';

/** Search, direction, outcome, date range (with custom dates) and Reset, in one bar. */
export default function CallFilters({ search, onSearch, filters, onChange, onReset }) {
  const set = (k) => (e) => onChange({ ...filters, [k]: e.target.value });
  return (
    <div className="panel cl-filters">
      <label className="cl-search"><Search size={15} /><input value={search} onChange={(e) => onSearch(e.target.value)} placeholder="Search by number or contact…" aria-label="Search calls" /></label>
      <label className="cl-field">Direction<select value={filters.direction} onChange={set('direction')}>
        <option value="">All directions</option><option value="inbound">Incoming</option><option value="outbound">Outgoing</option></select></label>
      <label className="cl-field">Outcome<select value={filters.status} onChange={set('status')}>
        <option value="">All outcomes</option><option value="answered">Answered</option><option value="missed">Missed</option><option value="failed">Failed</option></select></label>
      <label className="cl-field">Date<select value={filters.range} onChange={set('range')}>
        <option value="">Any date</option>{Object.entries(RANGES).map(([k, [label]]) => <option key={k} value={k}>{label}</option>)}</select></label>
      {filters.range === 'custom' && (
        <>
          <label className="cl-field">From<input type="date" value={filters.from} max={filters.to || undefined} onChange={set('from')} /></label>
          <label className="cl-field">To<input type="date" value={filters.to} min={filters.from || undefined} onChange={set('to')} /></label>
        </>
      )}
      <button type="button" className="secondary-action cl-reset" onClick={onReset}><RotateCcw size={13} />Reset</button>
    </div>
  );
}
